import { useAnalytics } from '#~/analytics/index.js';
import { createBridgeLifecycleTracker } from '#~/analytics/domains/index.js';
import { PostHogFeatureFlag } from '#~/posthog/constants.js';
import { useFeatureFlag } from '#~/posthog/index.js';
import { usePopupStore } from '#~/store/popup.js';
import { Button } from '@studio/design-system/button';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { useMemo } from 'react';
import { twMerge } from 'cn';
import { Icon } from './icon.jsx';
import type { Props } from './types.js';

/** `<Linker>` component. */
export const Linker = ({ className, ...props }: Props): ReactElement => {
  const { setPopup } = usePopupStore();
  const { track } = useAnalytics();
  const bridgeLifecycleTracker = useMemo(() => createBridgeLifecycleTracker(track), [track]);

  const { enabled: isBridgeEnabled } = useFeatureFlag(PostHogFeatureFlag.BRIDGE_FEATURE, {
    defaultValue: false
  });

  const handleLink = useLatestFn(() => {
    // Open the bridge modal
    setPopup('bridge');
    bridgeLifecycleTracker.trackBridgeTrayOpened({ surface: 'bridge_linker' });
  });

  return (
    <div className={twMerge('flex flex-col items-center gap-12', className)} {...props}>
      <Icon className='mb-12 fill-secondary' />

      <p className='text-center font-regular text-muted'>
        First things first. To get started in your studio you must first install and link the{' '}
        {vendorName()} Bridge.
      </p>

      {isBridgeEnabled && (
        <Button onClick={handleLink} size='lg'>
          Link Bridge
        </Button>
      )}
    </div>
  );
};
